(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-chrono"] && !Shopify.designMode) return;
  try {
    (function () {
    var CLE = 'pm_chrono_panier';

    function peindre() {
      var el = document.querySelector('[data-cart-chrono]');
      if (!el) return null;
      var minutes = parseInt(el.getAttribute('data-minutes'), 10) || 10;

      var fin = parseInt(sessionStorage.getItem(CLE) || '0', 10);
      if (!fin || isNaN(fin) || fin < Date.now()) {
        /* Echeance passee : on ne relance pas, on laisse le bandeau masque.
           Un compteur qui repart en boucle, c'est ce qui trahit un faux. */
        if (fin && fin < Date.now()) return null;
        fin = Date.now() + minutes * 60000;
        try { sessionStorage.setItem(CLE, String(fin)); } catch (e) { return null; }
      }
      return { el: el, fin: fin, valeur: el.querySelector('[data-chrono-valeur]') };
    }

    var etat = null;
    var minuteur = null;

    function tic() {
      if (!etat) return;
      var reste = Math.max(0, etat.fin - Date.now());
      if (reste <= 0) {
        etat.el.hidden = true;
        clearInterval(minuteur);
        return;
      }
      var s = Math.floor(reste / 1000);
      var m = Math.floor(s / 60);
      etat.valeur.textContent = m + ':' + String(s % 60).padStart(2, '0');
      etat.el.hidden = false;
    }

    function demarrer() {
      clearInterval(minuteur);
      etat = peindre();
      if (!etat) return;
      tic();
      minuteur = setInterval(tic, 1000);
    }

    demarrer();
    /* Le tiroir se reconstruit a chaque ajout (replaceWith) : on repique. */
    document.addEventListener('cart:updated', function () { setTimeout(demarrer, 150); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    function markLoaded(img) {
      var media = img.closest('.product-card__media');
      if (media) media.classList.add('is-loaded');
    }
    /* 23/09 : le dos ne s'affiche qu'au survol souris (refonte-plus.css, @media (hover: hover)), donc
       JAMAIS sur telephone ; il y etait quand meme telecharge pour chaque carte (179 Ko sur /collections/mls)
       et retardait les vraies photos en 4G (derniere photo 9,3 s -> 6,2 s sans les dos). */
    var survol = !!(window.matchMedia && matchMedia('(hover: hover)').matches);
    function hydrateDos(img) {
      /* Le dos se precharge en meme temps que la face (a 800 px de l'ecran) : au
         survol il est deja la, la bascule est instantanee. */
      if (!survol) return;
      var c = img.closest('[data-rpc]'); var d = c && c.querySelector('img[data-dos-src]');
      if (!d) return;
      d.srcset = d.getAttribute('data-dos-srcset'); d.src = d.getAttribute('data-dos-src');
      d.removeAttribute('data-dos-src'); d.removeAttribute('data-dos-srcset');
    }
    function hydrate(img) {
      if (img.dataset.srcset) { img.srcset = img.dataset.srcset; img.removeAttribute('data-srcset'); }
      if (img.dataset.src) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
      hydrateDos(img);
    }
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        hydrate(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '800px 0px' }) : null;
    function scan() {
      document.querySelectorAll('.product-card__media img:not(.product-card__img--dos)').forEach(function (img) {
        if (!img.dataset.cardSeen) {
          img.dataset.cardSeen = '1';
          img.addEventListener('load', function () { markLoaded(img); }, { once: true });
          img.addEventListener('error', function () { markLoaded(img); }, { once: true });
        }
        if (img.complete && img.naturalWidth > 0) { markLoaded(img); }
        if (img.dataset.src) { if (io) io.observe(img); else hydrate(img); }
        else { hydrateDos(img); }   /* cartes chargees d'office (au-dessus du pli) : le dos suit tout de suite */
      });
    }
    var started = false;
    function start() { if (started) return; started = true; scan(); document.addEventListener('cart:updated', scan); }
    function whenReady() {
      var lcp = document.querySelector('img[fetchpriority="high"]:not(.site-header__logo-img)');
      if (lcp && !(lcp.complete && lcp.naturalWidth > 0)) {
        lcp.addEventListener('load', start, { once: true });
        lcp.addEventListener('error', start, { once: true });
        setTimeout(start, 3000);
      } else { start(); }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', whenReady);
    else whenReady();
  })();

  /* Ajout rapide depuis la carte : « + » -> rangee de tailles -> /cart/add.js ->
     cart:updated (le tiroir panier s'ouvre). Delegation sur document. */
  (function () {
    if (window.__rpcQuick) return; window.__rpcQuick = true;
    function fermerTout(sauf) {
      document.querySelectorAll('[data-rpc].is-quick').forEach(function (c) {
        if (c === sauf) return;
        c.classList.remove('is-quick');
        var q = c.querySelector('[data-rpc-quick]'); if (q) q.hidden = true;
        var p = c.querySelector('[data-rpc-plus]'); if (p) p.setAttribute('aria-expanded', 'false');
      });
    }
    document.addEventListener('click', function (e) {
      var plus = e.target.closest && e.target.closest('[data-rpc-plus]');
      if (plus) {
        e.preventDefault();
        var carte = plus.closest('[data-rpc]');
        var quick = carte.querySelector('[data-rpc-quick]');
        var ouvert = carte.classList.toggle('is-quick');
        quick.hidden = !ouvert;
        plus.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
        fermerTout(carte);
        return;
      }
      var close = e.target.closest && e.target.closest('[data-rpc-close]');
      if (close) { e.preventDefault(); fermerTout(null); return; }
      var add = e.target.closest && e.target.closest('[data-rpc-add]');
      if (add) {
        e.preventDefault();
        var c = add.closest('[data-rpc]');
        /* is-added aussi : un 2e tap pendant « ajouté » (0,9 s) remettait un article (Clarity n°19) */
        if (c.classList.contains('is-adding') || c.classList.contains('is-added')) return;
        c.classList.add('is-adding');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(add.getAttribute('data-rpc-add'), 10), quantity: 1 }] })
        }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function () {
            c.classList.remove('is-adding'); c.classList.add('is-added');
            document.dispatchEvent(new CustomEvent('cart:updated'));
            setTimeout(function () { c.classList.remove('is-added'); fermerTout(null); }, 900);
          })
          .catch(function () {
            c.classList.remove('is-adding');
            window.location.href = c.querySelector('.product-card__media').getAttribute('href');
          });
        return;
      }
      if (!(e.target.closest && e.target.closest('[data-rpc]'))) fermerTout(null);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fermerTout(null); });

    /* Le dos du maillot ne se charge qu'au premier survol souris (plus au toucher : invisible au telephone) de la
       carte : 24 cartes x 1 image de plus par page, ce serait le double de requetes
       pour un effet que la moitie des visiteurs ne declenchent jamais. */
    function chargerDos(e) {
      var c = e.target.closest && e.target.closest('[data-rpc]'); if (!c) return;
      var d = c.querySelector('img[data-dos-src]'); if (!d) return;
      d.srcset = d.getAttribute('data-dos-srcset'); d.src = d.getAttribute('data-dos-src');
      d.removeAttribute('data-dos-src'); d.removeAttribute('data-dos-srcset');
    }
    document.addEventListener('mouseover', chargerDos, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-offers"] && !Shopify.designMode) return;
  try {
    (function () {
    var box = document.querySelector('[data-pdp-offers]');
    if (!box) return;
    var form = box.closest('.pdp__info') && box.closest('.pdp__info').querySelector('.pdp__form');
    if (!form) return;
    function euros(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
    function unit() {
      var input = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"][type="hidden"]');
      return input ? parseInt(input.getAttribute('data-price'), 10) || 0 : 0;
    }
    function refresh() {
      var u = unit();
      if (!u) return;
      var t4 = u * 3;
      var set = function (sel, v) { var el = box.querySelector(sel); if (el) el.textContent = euros(v); };
      set('[data-tier-total="1"]', u);
      set('[data-tier-total="4"]', t4); set('[data-tier-each="4"]', Math.round(t4 / 4));
    }
    form.addEventListener('change', refresh);
    refresh();
  })();
  } catch(e) { console.error(e); }
})();

})();
